import { Card } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquare, FileText, Video, Calendar } from "lucide-react";
import { TeamChat } from "@/components/communication/TeamChat";
import { FileBrowser } from "@/components/communication/FileBrowser";
import { VideoPortal } from "@/components/communication/VideoPortal";
import { ScheduleGrid } from "@/components/communication/ScheduleGrid";

export const CareCoordination = () => {
  return (
    <div className="space-y-8 animate-fade-in">
      <Tabs defaultValue="chat" className="w-full">
        <TabsList className="flex flex-nowrap overflow-x-auto scrollbar-hide gap-2 mb-8 p-1 bg-transparent">
          <TabsTrigger value="chat" className="flex items-center gap-2 whitespace-nowrap min-w-fit">
            <MessageSquare className="w-4 h-4" />
            <span className="truncate">Team Chat</span>
          </TabsTrigger>
          <TabsTrigger value="files" className="flex items-center gap-2 whitespace-nowrap min-w-fit">
            <FileText className="w-4 h-4" />
            <span className="truncate">Files</span>
          </TabsTrigger>
          <TabsTrigger value="video" className="flex items-center gap-2 whitespace-nowrap min-w-fit">
            <Video className="w-4 h-4" />
            <span className="truncate">Video</span>
          </TabsTrigger>
          <TabsTrigger value="schedule" className="flex items-center gap-2 whitespace-nowrap min-w-fit">
            <Calendar className="w-4 h-4" />
            <span className="truncate">Schedule</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="chat">
          <TeamChat />
        </TabsContent>
        
        <TabsContent value="files">
          <FileBrowser />
        </TabsContent>
        
        <TabsContent value="video">
          <VideoPortal />
        </TabsContent>
        
        <TabsContent value="schedule">
          <ScheduleGrid />
        </TabsContent>
      </Tabs>
    </div>
  );
};